import { render, staticRenderFns } from "./DeviceWarning.vue?vue&type=template&id=610095e6&scoped=true&"
import script from "./DeviceWarning.vue?vue&type=script&lang=js&"
export * from "./DeviceWarning.vue?vue&type=script&lang=js&"
import style0 from "./DeviceWarning.vue?vue&type=style&index=0&id=610095e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610095e6",
  null
  
)

export default component.exports